(function () {
    'use strict';

    angular
        .module('app.deleteAccount')
        .factory('deleteAccountService', ['$q', '$http', '$rootScope',
            function ($q, $http, $rootScope) {
                var service = {};

                function checkResponse(data) {
                  return data;
                }

                function getMessage(data) {
                  if (data) {
                    return data.message;
                  }
                  return false;
                }

                function handleRequest(url, method, params, loader) {
                    var deferred = $q.defer();

                    var req = {
                        url: url,
                        method: method,
                        data: JSON.stringify(params),
                        loader: loader
                    } 

                    $http(req)
                        .success(function (data) {
                        var dataRes = angular.fromJson(data);

                        if (checkResponse(dataRes)) {
                            deferred.resolve(dataRes);
                        } else {
                            deferred.reject(getMessage(dataRes));
                        }
                    })
                        .error(function (error) {
                            deferred.reject(error);
                        });

                    return deferred.promise;
                }

                function deleteAccount(account_id, loader) {
                    var url_deleteAccount = $rootScope.apiUrl + 'company/deleteAccount/' + account_id;
                    return handleRequest(url_deleteAccount, 'DELETE', null, loader);
                }

                service.deleteAccount = deleteAccount;

                return service;
            }
        ]);
})();
